import { render, staticRenderFns } from "./GroupsCrud.vue?vue&type=template&id=c35fbef8&scoped=true"
import script from "./GroupsCrud.vue?vue&type=script&lang=js"
export * from "./GroupsCrud.vue?vue&type=script&lang=js"
import style0 from "./GroupsCrud.vue?vue&type=style&index=0&id=c35fbef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35fbef8",
  null
  
)

export default component.exports